import React from "react";
import { HashRouter as Router, Switch, Redirect } from "react-router-dom";

/** Layouts */
import ErrorLayout from "./Views/ErrorView/route";
import CommonLayout from "./Views/CommonView/route";
import HomeLayout from "./Views/HomeView/route";

/** Pages */
import Home from "./Pages/Home";
import Systemy from "./Pages/RSISYSTEMY";
import SystemyInfo from "./Pages/RSISYSTEMY/infopage";
import Gestorzy from "./Pages/RSIGESTORZY";
import GestorzyInfo from "./Pages/RSIGESTORZY/infopage";
import Obiekty from "./Pages/RSIOBIEKTY";
import Cechy from "./Pages/RSICECHY";
import CechyInfo from "./Pages/RSICECHY/infopage";
import Deklaracja from "./Pages/Deklaracja";
import Error404 from "./Pages/Errors/404";
import Error403 from "./Pages/Errors/403";

export default function Routes() {
    return (
        <Router>
            <Switch>
                <HomeLayout exact path="/" component={Home} />

                <CommonLayout exact path="/rsisystemy" component={Systemy} />
                <CommonLayout path="/rsisystemy/:id" component={SystemyInfo} />

                <CommonLayout exact path="/rsigestorzy" component={Gestorzy} />
                <CommonLayout exact path="/rsigestorzy/:id" component={Gestorzy} />
                <CommonLayout path="/rsigestorzy/info/:id" component={GestorzyInfo} />

                <CommonLayout exact path="/rsiobiekty" component={Obiekty} />
                <CommonLayout path="/rsiobiekty/:id" component={Obiekty} />

                <CommonLayout exact path="/rsicechy" component={Cechy} />
                <CommonLayout path="/rsicechy/:id" component={CechyInfo} />

                <CommonLayout exact path="/deklaracja" component={Deklaracja} />

                <ErrorLayout exact path="/404" component={Error404} />
                <ErrorLayout exact path="/denied" component={Error403} />
                <ErrorLayout path="/*" component={() => <Redirect to="/404" />} />
            </Switch>
        </Router>
    );
}
